<template>
  <div class="u-floatRight userMenu">
    <div class="fpds-ActionMenu">
      <div class="fpds-ActionMenu-trigger gravitar">
        <img
          v-if="picture && picture.length"
          :src="picture"
          alt="Fisher & Paykel Healthcare"
          style="max-width: none"
        />
        <span v-if="!picture || !picture.length">{{ fullName }}</span>
      </div>
      <div class="fpds-ActionMenu-popover fpds-Popover is-bottomRight">
        <ul class="fpds-ActionMenu-menu fpds-Menu">
          <li class="profileDetail u-paddingTopSmall">
            <div class="u-flex u-paddingLeftSmall">
              <div class="gravitar u-flexInitial">
                <img v-if="picture" :src="picture" alt="Fisher & Paykel Healthcare" />
              </div>
              <div class="u-flexFill u-paddingLeftXSmall u-paddingRightLarge">
                <div class="u-fontBold">{{ fullName }}</div>
                <div class="u-textSecondary fpds-Caption">{{ email }}</div>
              </div>
            </div>
            <hr class="fpds-Divider u-marginBottomXSmall" />
          </li>
          <li class="fpds-Menu-item">
            <div class="fpds-Menu-itemLabel" tabindex="0" @click="logOut">Log out</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import ProfileService from "../services/ProfileService";

export default {
  name: "UserMenu",
  computed: {
    picture() {
      return this.$store.state.currentProfile.picture;
    },
    email() {
      return this.$store.state.currentProfile.email;
    },
    fullName() {
      return `${this.$store.state.currentProfile.firstName} ${this.$store.state.currentProfile.lastName}`;
    },
  },
  async mounted() {
    window.FPDS.ActionMenu.initAll();
  },
  methods: {
    logOut() {
      ProfileService.logOut();
    },
  },
};
</script>
